import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=07a53d93&scoped=true&"
import script from "./UserAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserAccount.vue?vue&type=style&index=0&id=07a53d93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a53d93",
  null
  
)

export default component.exports